const EN_US = {
  'foodstormDomain.title': 'Foodstorm',
  'foodstormDomain.educationalBanner.heading':
    'Expand your Deli assortment on Instacart App with the power of FoodStorm',
  'foodstormDomain.educationalBanner.information':
    'FoodStorm is Instacart’s order management system built for grocery food service and integrates with your Instacart App listing to help bring more customized deli assortment online with streamlined in-store production.',
  'foodstormDomain.educationalBanner.buttonText': 'Book a Demo',
} as const

export default EN_US
